import { setAside } from '../actions';
import { createReducer, forAction, identityPayload } from '../utils';

const initialState = false;

export default createReducer(
  [forAction(setAside, identityPayload)],
  initialState,
);
